import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MetaPagination, SectionResponse, OverlapFiltersResponse } from '../../../api';

const getOffersAndBookingsState = createFeatureSelector('offersAndBookings');

export const getOfferOverlapsList = createSelector(
  getOffersAndBookingsState,
  (
    state: any
  ): {
    data: SectionResponse[] | undefined;
    pagination: MetaPagination | undefined;
    filters: OverlapFiltersResponse | undefined;
    ok: boolean | undefined;
  } => state.offerOverlapsList
);
